import { useMemo } from 'react';

/** @type {(vhType: import('@core/models/virtualhuman.types').VHType) => boolean} */
export const isV3VH = (vhType) => {
  return vhType === 'freeform_v3' || vhType === 'medical_v3';
};

/** @type {(vhType: import('@core/models/virtualhuman.types').VHType) => boolean} */
export const useIsV3VH = (vhType) => {
  return useMemo(() => {
    return isV3VH(vhType);
  }, [vhType]);
};
